const validateHashOrigin = (hash) => {
  const regex = hash.replace(/[^0-9]+/g, '');
  const isFromOldVerifica = regex.length < 16;
  return isFromOldVerifica ? hash : hash.replaceAll('-', '');
};

module.exports = validateHashOrigin;
